module.exports = __webpack_public_path__ + "media/images/emblems/Plaffeien-coat_of_arms-8da72d476de6f9aad4cc42ca99c26269.svg";